<template>
  <b-row class="mb-1">
    <b-col cols="5">
      <b-form-group
        label="Escolha um campo"
      >
        <b-select
          v-model="form.opcaoSelecionada"
          :options="opcoes"
          @change="alterarDados"
        />
      </b-form-group>
    </b-col>
    <b-col cols="4">
      <enquadramento-select
        v-if="form.opcaoSelecionada === 'Enquadramento'"
        v-model="form.filtrosValores"
        :multiple="true"
        :disabled="form.semConfiguracao"
        @input="setFiltrosSelecionados($event)"
      />
      <legend
        v-if="form.opcaoSelecionada === 'CNAE'"
        style="font-size: inherit;"
      >
        CNAE</legend>
      <b-form-tags
        v-if="form.opcaoSelecionada === 'CNAE'"
        v-model="form.filtrosSelecionado"
        placeholder=""
        separator=" "
        duplicate-tag-text=""
        :add-button-text="'Adicionar'"
        remove-on-delete
        tag-class="tags"
      />
      <equipe-select
        v-if="form.opcaoSelecionada === 'Equipe'"
        v-model="form.filtrosValores"
        :multiple="true"
        :disabled="form.semConfiguracao"
        @input="setFiltrosSelecionados($event)"
      />
      <legend
        v-if="form.opcaoSelecionada === 'UF'"
        style="font-size: inherit;"
      >
        UF - Endereço</legend>
      <estado-select
        v-if="form.opcaoSelecionada === 'UF'"
        v-model="form.filtrosValores"
        :multiple="true"
        @input="setFiltrosSelecionados($event)"
      />
      <legend
        v-if="form.opcaoSelecionada === 'Cidade'"
        style="font-size: inherit;"
      >
        Cidade</legend>
      <municipio-select
        v-if="form.opcaoSelecionada === 'Cidade'"
        v-model="form.filtrosValores"
        :multiple="true"
        @input="setFiltrosSelecionados($event)"
      />
      <modelo-select
        v-if="form.opcaoSelecionada === 'Modelo'"
        v-model="form.filtrosValores"
        :multiple="true"
        :disabled="form.semConfiguracao"
        @input="setFiltrosSelecionados($event)"
      />
      <contato-select
        v-if="form.opcaoSelecionada === 'Contato'"
        v-model="form.filtrosValores"
        :multiple="true"
        :disabled="form.semConfiguracao"
        @input="setFiltrosSelecionados($event)"
      />
      <responsavel-select
        v-if="form.opcaoSelecionada === 'Responsavel'"
        v-model="form.filtrosValores"
        :label="'Usuário Responsável'"
        :multiple="true"
        :disabled="form.semConfiguracao"
        @input="setFiltrosSelecionados($event)"
      />
      <socio-select
        v-if="form.opcaoSelecionada === 'Socios'"
        v-model="form.filtrosValores"
        :multiple="true"
        :disabled="form.semConfiguracao"
        @input="setFiltrosSelecionados($event)"
      />
      <legend
        v-if="form.opcaoSelecionada === 'EmailsBoletosNFs'"
        style="font-size: inherit;"
      >
        E-mail para Recebimento de Boletos e Notas Fiscais
      </legend>
      <b-form-tags
        v-if="form.opcaoSelecionada === 'EmailsBoletosNFs'"
        v-model="form.filtrosSelecionado"
        style="margin-bottom: 1rem;"
        :disabled="form.semConfiguracao"
        placeholder=""
        separator=" "
        duplicate-tag-text=""
        :add-button-text="'Adicionar'"
        remove-on-delete
        tag-class="tags"
      />
      <b-form-checkbox
        v-if="mostrarSemInformacaoCheck"
        v-model="form.semConfiguracao"
        :value="true"
        :unchecked-value="false"
        class="detail-check-sm"
        style="margin-top: -0.8rem;"
        @change="removerFiltro"
      >
        Sem informação
      </b-form-checkbox>
    </b-col>
    <b-col v-if="form.opcaoSelecionada">
      <legend class="col-form-label pt-2" />
      <div style="padding-top:3.2px">
        <div style="display: inline-block;">
          <b-btn
            variant="none"
            class="btn-none btn-outline-success rounded-pill icone-filtro btn-sm mr-50"
            @click.prevent.stop="adicionar()"
          >
            <feather-icon
              icon="PlusIcon"
            />
          </b-btn>
          <b-btn
            v-if="quantidadeItens > 1"
            variant="none"
            class="btn-outline-danger rounded-pill icone-filtro btn-sm"
            @click.prevent.stop="remover()"
          >
            <feather-icon
              icon="MinusIcon"
            />
          </b-btn>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<style lang="scss">
.icone-filtro {
  padding: 0.4rem;
}

.tags {
  font-size: 12.6px;
}

.detail-check-sm.custom-checkbox.b-custom-control-sm
  .custom-control-label::before,
.detail-check-sm.input-group-sm .custom-checkbox .custom-control-label::before {
  left: 0px !important;
}

.detail-check-sm.custom-checkbox.b-custom-control-sm .custom-control-label {
  font-size: 1rem !important;
}
</style>

<script>

export default {
  name: 'FiltroConfiguravel',
  components: {
    EnquadramentoSelect: () => import('@/shared/components/enquadramento-select/EnquadramentoSelect.vue'),
    EquipeSelect: () => import('@/shared/components/equipe-select/EquipeSelect.vue'),
    EstadoSelect: () => import('@/shared/components/estado-select/EstadoSelect.vue'),
    MunicipioSelect: () => import('@/shared/components/municipio-select/MunicipioSelect.vue'),
    ModeloSelect: () => import('@/shared/components/modelo-select/ModeloSelect.vue'),
    ContatoSelect: () => import('@/shared/components/usuario-externo-select/UsuarioExternoSelect.vue'),
    ResponsavelSelect: () => import('@/shared/components/usuario-interno-select/UsuarioInternoSelect.vue'),
    SocioSelect: () => import('@/shared/components/socio-select/SocioSelect.vue'),
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    quantidadeItens: {
      type: Number,
      default: () => 1,
    },
  },
  data() {
    return {
      opcoes: [
        { value: 'Cidade', text: 'Cidade' },
        { value: 'CNAE', text: 'CNAE' },
        { value: 'Contato', text: 'Usuário - contato' },
        { value: 'EmailsBoletosNFs', text: 'E-mail para Recebimento de Boletos e Notas Fiscais' },
        { value: 'Enquadramento', text: 'Enquadramento' },
        { value: 'Equipe', text: 'Equipe' },
        { value: 'Modelo', text: 'Modelo' },
        { value: 'Responsavel', text: 'Usuário - responsável' },
        { value: 'Socios', text: 'Sócio' },
        { value: 'UF', text: 'UF - Endereço' },
      ],
      form: {},
      duplicateTags: [],
    }
  },
  computed: {
    mostrarSemInformacaoCheck() {
      return this.form.opcaoSelecionada === 'Modelo' || this.form.opcaoSelecionada === 'Contato'
            || this.form.opcaoSelecionada === 'Responsavel' || this.form.opcaoSelecionada === 'Equipe' || this.form.opcaoSelecionada === 'Enquadramento' || this.form.opcaoSelecionada === 'EmailsBoletosNFs'
    },
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.form = value
      }
    },
  },
  created() {
    this.form = this.value
  },
  methods: {
    setFiltrosSelecionados(values) {
      this.form.filtrosSelecionado = []
      if (this.form.opcaoSelecionada === 'Enquadramento' || this.form.opcaoSelecionada === 'Equipe'
        || this.form.opcaoSelecionada === 'UF' || this.form.opcaoSelecionada === 'Cidade' || this.form.opcaoSelecionada === 'Modelo') {
        values.forEach(each => {
          this.form.filtrosSelecionado.push(each.nome)
        })
      } else if (this.form.opcaoSelecionada === 'Contato' || this.form.opcaoSelecionada === 'Responsavel' || this.form.opcaoSelecionada === 'Socios') {
        values.forEach(each => {
          this.form.filtrosSelecionado.push(each.nomeCompleto)
        })
      }
      this.form.semConfiguracao = false
    },
    alterarDados() {
      this.form.semConfiguracao = false
      this.removerFiltro()
    },
    removerFiltro() {
      this.$set(this.form, 'filtrosSelecionado', [])
      this.form.filtrosValores = []
    },
    adicionar() {
      this.$emit('adicionar')
    },
    remover() {
      this.$emit('remover', this.form.code)
    },
  },
}
</script>
